import { getDirectory } from '@src/quince-components/src/atoms/breadCrumb/breadcrumb.helper'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'

import { renderProductImages } from './ProductImages'
import { getImagesSortedByColor } from './productImages.helper'

interface BundleProductImagesProps {
  bundle: Bundle
  selectedColor: string
}

const BundleProductImages = (props: BundleProductImagesProps) => {
  const sortedProductMedia = getImagesSortedByColor(props.bundle.images, props.selectedColor)
  const sortedFilteredProductMedia = sortedProductMedia.slice(0, 10)

  const directory = getDirectory(props.bundle.slug, props.bundle.title, props.bundle.hierarchy ?? undefined)

  return renderProductImages({
    productSlug: props.bundle.slug,
    productMedia: sortedFilteredProductMedia,
    productTitle: props.bundle.title,
    productHierarchy: props.bundle.hierarchy ?? undefined,
    hasSelectedOptionImages: true,
    hideWishList: true,
    directory: directory,
    productTags: props.bundle.tags,
  })
}

export default BundleProductImages
